 
import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { SeCheckbox, SeLink, SeIcon } from "@se/web-ui-react";
import CryptoJS from "crypto-js";
import FileDownload from "js-file-download";
// const FileDownload = require("js-file-download");
import Services from "./DeployPages/Services";
import DownloadController from "./DeployPages/DownloadController";
import LicenceKeys from "./DeployPages/LicenceKeys";

import useMountEffect from "./CustomHooks/useMountEffect";
import userScope from "./CustomHooks/userScope";
import Snackbar from "./SE-Component/Snackbar";
import AlertIcon from "./SE-Component/AlertIcon";
//*api call
import ApiSession from "../api/ApiSession";
import ProgressBarContainer from "../components/progressBar/progressBarContainer";
import { useDispatch, useSelector } from "react-redux";
import { getProjectInfoRequest } from "../redux/features/projectStatusInfoSlice";

import "./deployHook.scss";
import { upDateProjectType } from "../redux/features/projectTypeSlice";
import SupportDocument from "./supportDocument";
import {
  initialTypes,
  projectKindReducer,
} from "./DesignAssets/Reducers/projectKindReducer";
import embLabels from "../config/emb-labels-en.json";
import { DAAS_ANSI, DAAS_ETO, MGAAS_ANSI, NMGAAS_ETO } from "../utils/application.constants";
import getOnlogicDecrypted, { decrypt } from "../utils/onlogic";
import useProjectTypeValue from "../utils/useCurrentProjectValue";
import { withRouter } from "react-router-dom";
import { useAtom } from "jotai";
import { projectAtomList } from "../atoms";
import DownloadConfiguration from "./DownloadConfiguration";
import keyImagePLC from "../images/se-plc.png";
import keyImageIPC from "../images/se_iPC2.jpg";
import IOConfig from "./IOConfig";
import { sendCallToActionEvent } from "../utils/gaHelper";
import DownloadBessController from "./DownloadBessController";
const apiSession = new ApiSession();

//* RegEx
const alphanumericReg = /^([a-zA-Z0-9]+)$/;
// const serialNoRegex = /^[a-zA-Z0-9]{8}[0-9]{5}$/;
const serialNoRegex_13 = /^[a-zA-Z0-9]{8}[0-9]{5}$/;
const serialNoRegex_10 = /^[a-zA-Z0-9]{5}[0-9]{5}$/;

const Deploy = (props) => {
  const UserScope = userScope();
  const { projectId } = props?.match?.params;
  const [loading, setLoading] = useState(false);

  const [unlockDeploy, setUnlockDeploy] = useState(false);
  const [emaSiteStatus, setEmaSiteStatus] = useState(false);
  const [emaSiteId, setEmaSiteId] = useState("");
  const [deployMessage, setDeployMessage] = useState("");
  const [resetPlcPopUpStatus, setResetPlcPopUpStatus] = useState(false);

  const [siteType, setSiteType] = useState("");
  const [bessControllerAvailable, setBessControllerAvailable] = useState(false);
  const [masterBessControllerAvailable, setMasterBessControllerAvailable] = useState(false);
  const [clientType, setClientType] = useState("");
  const [architectureType, setArchitectureType] = useState("");
  const [emoSerialNumber, setEmoSerialNumber] = useState(null);
  const [ipcSerialNumber, setipcSerialNumber] = useState(null);
  const [open, setOpen] = useState(false);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [openSiteCreate, setOpenSiteCreate] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState({
    isOpen: false,
    packageType: "",
  });
  const [fileType, setFileType] = useState("");
  const [uploadedPackage, setUploadedPackage] = useState({});
  const [programTitle, setProgramTitle] = useState("");
  const inputRefFile = useRef(null);
  const [projectKind, projectKindDispatch] = useReducer(
    projectKindReducer,
    initialTypes
  );
  const [downloadProgram, setDownloadProgram] = useState({
    isOpen: false,
    packageType: "",
  });
  const [downloadController, setDownloadController] = useState({
    isOpen: false,
    packageType: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileInfo, setFileInfo] = useState({
    name: "",
    description: "",
  });
  const [bessControllerList, setBessControllerList] = useState([]);
   const [bessControllerListJson, setBessControllerListJson] = useState([]);
     const [latestVersionMap, setLatestVersionMap] = useState({});

  const projectTypeValue = useProjectTypeValue();

  const dialogHandler = () => {
    handleChangeProjectStatus(
      projectStatusClick === "Completed & Send"
        ? "COMPLETED_AND_SEND"
        : "COMPLETED"
    );
  };

  const [orderNumber, setOrderNumber] = useState("");
  const [emoDocList, setEmoDocList] = useState({});
  const [orderNumberError, setOrderNumberError] = useState(false);
  const [keyExpert, setKeyExpert] = useState({
    expertKey: "",
    expertStatus: false,
    KeyErrorStatusExpert: false,
    expertKeyInvalid: false,
    expertExpired: false,
  });
  const [keyOperations, setKeyOperations] = useState({
    operationKey: "",
    operationsStatus: false,
    KeyErrorStatusOperations: false,
    operationKeyInvalid: false,
    operationExpired: false,
  });
  const [gridSetting, setGridSetting] = useState({
    userInterface: true,
    remoteMonitoringControl: true,
  });
  const [pagesValidated, setPagesValidated] = useState({
    programPage: true,
    systemsPage: true,
  });
  const [versions, setVersions] = useState({
    plcVersion: "",
    hmiVersion: "",
  });
  const [lockedStatus, setLockedStatus] = useState({
    unlockDeploy: false,
    plcLocked: false,
  });
  const [emoController, setEmoController] = useState({
    plcKeyPopUp: false,
    serialNo: "",
    KeyErrorStatusSerialNo: false,
  });
  const [ipcController, setIpcController] = useState({
    ipcKeyPopUp: false,
    serialNo: "",
    KeyErrorStatusSerialNo: false,
  });
  const [snackBar, setSnackBar] = useState({ type: "", message: "" });
  const [alert, setAlert] = useState({
    message: "",
    alertPopUpStatus: false,
    title: "",
    isRoute: false,
    routePath: "",
  });
  const [confirm, setConfirm] = useState({
    deleteSiteAlertPopUp: false,
  });
  const [projectStateChanges, setProjectStateChanges] = useState();
  const snackBarRef = useRef(null);
  const dispatch = useDispatch();

  const [currentProject, setCurrentProject] = useAtom(projectAtomList);
  // const projectStatusInfo = useSelector((state) => state.projectType);
  const projectStatusInfo = currentProject?.projectStatus;

  const [showSupportDocumentDialog, setShowSupportDocumentDialog] =
    useState(false);
  const [showConfig, setShowConfig] = useState(false);
  const [gatewayType, setGatewayType] = useState();
  const [documentList, setDocumentList] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [projectStatusClick, setProjectStatusClick] = useState("");
  const [deploymentStatusResponse, setDeploymentStatusResponse] = useState(null);
  useMountEffect(() => {
    if (projectId === null) {
      setAlertMessage(
        `Deploy Page`,
        true,
        `information/new`,
        `Please create project and then visit deploy page.`
      );
    } else {
      if (UserScope?.access?.deploymentStatus) {
        setLoading(true);
        getDeploymentStatus();
      }
      getEMASite(false);
    }
  }, [projectStateChanges]);

  useEffect(() => {
    if (projectStatusInfo?.projectStatus) {
      setOrderNumber(projectStatusInfo?.q2cOrderNumber);
      if (projectStatusInfo?.projectStatus === "IN_PROGRESS") {
        setOpenStatusDialog(true);
      }
      getAllDocuments();
    }
    getEmoDoc()
  }, [projectStatusInfo?.projectStatus]);
useEffect(() => {
  loadToolTip();
  
 
 },[])

   const loadToolTip = () => {
    setLoading(true);
    apiSession
      .getToolTip("information", "EN").then((json) => {
        if(json){
          setCurrentProject(prev=>{
            return{
              ...prev,
              tooltipData: json
            }
          });
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const getBessControllerPackagesList = () => {
    try {
      apiSession.getUploadedControllerPackagesListAPI()
      .then((response) => {
        setBessControllerList(response);
        setBessControllerListJson(response);
       const latestVersionsMap = latestVersions(response);
       console.log(latestVersionsMap)
         setLatestVersionMap(latestVersionsMap);
      })
    } catch (error) {
      console.log("Error fetching uploaded BESS controller packages list:", error);
    }
  }
  //* project status handles
  const handleChangeProjectStatus = (status) => {
    apiSession
      .changeProjectStatus({
        projectId: projectId,
        projectStatus: status,
        q2cOrderNumber: orderNumber,
      })
      .then((response) => {
        setProjectStateChanges(status);

        if (response) {
          // dispatch(upDateProjectType(response));
          setCurrentProject((prevData) => ({
            ...prevData,
            projectStatus: response,
          }));
        }

        if (status === "COMPLETED" || status === "COMPLETED_AND_SEND") {
          setOpen(!open);
        }
        if (response?.orderNumber) {
          setOrderNumber(response?.q2cOrderNumber);
        }
      })
      .catch((error) => {
        if (error.response !== undefined) {
          if (error.response.status === 412) {
            callSnackbar("error", `${error.response.data.message}`);
          }
        }
      });
    //dispatch(getProjectInfoRequest());
    setOpen(false);
    // if(status === "COMPLETED"){
    //   setOpen(!open)
    // }
    // else{
    //   setUnlockDeploy(true)
    // }
  };

   
  const getDeploymentStatus = () => {
    apiSession
      .getDeploymentStatus(projectId)
      .then((response) => {
        if(response){
        setDeploymentStatusResponse(response);
        let licenses = [];
        licenses = response?.licenses;
        setGatewayType(response?.gatewayType);
        setKeyExpert((prevState) => ({
          ...prevState,
          expertStatus: false,
          expertExpired: false,
        }));
        setKeyOperations((prevState) => ({
          ...prevState,
          operationsStatus: false,
          operationExpired: false,
        }));

        // if (licenses.length) {
        //   if (licenses.indexOf("EXPERT") > -1) {
        //     setKeyExpert((prevState) => ({ ...prevState, expertStatus: true }));
        //   }
        //   if (licenses.indexOf("OPERATIONS") > -1) {
        //     setKeyOperations((prevState) => ({
        //       ...prevState,
        //       operationsStatus: true,
        //     }));
        //   }
        //   if (licenses.indexOf("EXPERT_EXPIRED") > -1) {
        //     setKeyExpert((prevState) => ({
        //       ...prevState,
        //       expertExpired: true,
        //     }));
        //   }
        //   if (licenses.indexOf("OPERATIONS_EXPIRED") > -1) {
        //     setKeyOperations((prevState) => ({
        //       ...prevState,
        //       operationExpired: true,
        //     }));
        //   }
        // }

        setUnlockDeploy(response?.deploymentStatus);
        setPagesValidated((prevState) => ({
          ...prevState,
          programPage: response?.programPage,
          systemsPage: response?.systemsPage,
        }));

        setVersions({
          ...versions,
          plcVersion: response?.plcVersion,
          hmiVersion: response?.hmiVersion,
        });

        const gridSettings = { ...gridSetting };
        gridSettings.userInterface = response?.hmiSelected;
        gridSettings.remoteMonitoringControl = response?.remoteMonitoring;
        setGridSetting(gridSettings);
        setLockedStatus((prevState) => ({
          ...prevState,
          unlockDeploy: response?.deploymentStatus,
          plcLocked: response?.plcLocked,
        }));
        setSiteType(response?.siteType);
        setBessControllerAvailable(response?.bessController);
        setMasterBessControllerAvailable(response?.masterBessController);
        setClientType(response?.clientType);
        setArchitectureType(response?.architecture);
        setEmoSerialNumber(response?.serialNumber);
        setipcSerialNumber(response?.emaCSerialNumber);
        if(response?.bessController || response?.masterBessController){
          getBessControllerPackagesList();
        }
        if (response?.serialNumber) {
          setEmoController((prevState) => ({
            ...prevState,
            serialNo: response?.serialNumber,
          }));
        }
        if (response?.emaCSerialNumber) {
          setIpcController((prevState) => ({
            ...prevState,
            serialNo: response?.emaCSerialNumber,
          }));
        }
        setLoading(false);
      }
      })
      .catch(() => {
        setPagesValidated((prevState) => ({
          ...prevState,
          programPage: true,
          systemsPage: true,
        }));
        setKeyExpert((prevState) => ({
          ...prevState,
          expertStatus: false,
          expertExpired: false,
        }));
        setKeyOperations((prevState) => ({
          ...prevState,
          operationsStatus: false,
          operationExpired: false,
        }));
        setLockedStatus((prevState) => ({
          ...prevState,
          unlockDeploy: false,
          plcLocked: false,
        }));
        setLoading(false);
      });
  };

  //* Cloud servie
   
  const getEMASite = (update) => {
    try {
      apiSession
        .getEMASite(projectId)
        .then((response) => {
          if (update === true) {
            if (response?.reConfigured === "true") {
              setAlertMessage(
                `Alert`,
                false,
                ``,
                `Download EMA controller configuration as EMA website has been updated.`
              );
            }
          }

          if (response?.siteId) {
            setEmaSiteId(response.siteId);
          }
          setEmaSiteStatus(true);
        })
        .catch(() => {
          setEmaSiteStatus(false);

          setEmaSiteId("");
        });
    } catch (error) {
      console.log(error);
    }
  };
   
  const createSiteInEMA = (status="") => {
    if (
      pagesValidated?.programPage === false &&
      pagesValidated?.systemsPage === false
    ) {
      setLoading(true);

      apiSession
        .createEMAsite(projectId)
        .then(() => {
          callSnackbar(`success`, `${status === "updated" ? "site updated successfully" : "site created successfully"}`);
          setLoading(false);
          getEMASite(true);
        })
        .catch((error) => {
            if (error?.response?.status === 403) {
              callSnackbar(
                `error`,
                `Unauthorised to perform this action, Contact administrator.`
              );
            } else if (error?.response?.status === 400) {
              callSnackbar(
                `error`,
                `${
                  error.response.data === null
                    ? "Error in site creation"
                    : error.response.data.message || "Something went wrong"
                }`
              );
            } else {
              callSnackbar(
                `error`,
                `${
                  error?.response?.data === null
                    ? "Error in site creation"
                    : error?.response.data.message
                }`
              );
            }
          setLoading(false);
          getEMASite();
        });
    } else {
      if (pagesValidated?.programPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate use case to proceed further in Configure use cases.`
        );
      } else if (pagesValidated?.systemsPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate communication settings to proceed further.`
        );
      }
    }
  };
  const navigateToEMOM = () => {
    window.location.href = `/platform/project/${projectId}/${emaSiteId}`;
  }
  /* istanbul ignore next */
  const deleteSiteInEMA = () =>
    setConfirm((prevState) => ({ ...prevState, deleteSiteAlertPopUp: true }));
  const cancelDeleteSite = () =>
    setConfirm((prevState) => ({ ...prevState, deleteSiteAlertPopUp: false }));

  const confirmDeleteSite = () => {
    if (UserScope.access.deleteSite) {
      setConfirm((prevState) => ({
        ...prevState,
        deleteSiteAlertPopUp: false,
      }));
      setLoading(true);

      apiSession
        .deleteEMASite(projectId)
        .then(() => {
          setLoading(false);

          callSnackbar("success", "Cloud service deleted successfully");
          getEMASite(false);
        })
        .catch((error) => {
          setLoading(false);

          getEMASite(false);
          if (error.response) {
            if (
              error.response.status === 400 ||
              error.response.status === 500
            ) {
              callSnackbar("error", error.response.data.message);
            }
          } else {
            callSnackbar("error", "Error in deletion of Cloud service");
          }
        });
    } else {
      setConfirm((prevState) => ({
        ...prevState,
        deleteSiteAlertPopUp: false,
      }));
      callSnackbar(
        "error",
        "User doesn't have permission to delete the cloud service"
      );
      getEMASite(false);
    }
  };

  //* IPC
   
  const downloadIpcFile = () => {
    let emaCSerialNumber =  ipcController.serialNo
    if (!emaSiteStatus) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `Configure cloud services before downloading EMA controller configuration.`
      );
    } else {
      if (!pagesValidated.programPage) {
        setLoading(true);
        apiSession
          .downloadIPC(projectId, emaCSerialNumber)
          .then((response) => {
            FileDownload(
              response,
              `${projectStatusInfo?.projectName}_EMAController.zip`
            );
            callSnackbar("success", "Downloaded successfully");
            setLoading(false);
          })
          .catch((error) => {
            if (error.response !== undefined) {
              let enc = new TextDecoder("utf-8");
              let arr = new Uint8Array(error.response.data);
              let resultBuf = JSON.parse(enc.decode(arr));
              callSnackbar(
                "error",
                resultBuf.message !== undefined
                  ? resultBuf.message
                  : "Error in IPC Download"
              );
            } else {
              callSnackbar("error", "Error in IPC Download");
            }
            setLoading(false);
          });
      } else {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate use case to proceed further in Configure use cases.`
        );
      }
    }
  };
  const downloadOnLogicFile = () => {
    if (!emaSiteStatus) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `Configure cloud services before downloading EMA controller configuration.`
      );
    } else {
      if (!pagesValidated.programPage) {
        console.log("Downloaded");
      } else {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate use case to proceed further in Configure use cases.`
        );
      }
    }
  };
  //* PLC

  const handleSerialNoPopUp = (type) => {
    if (lockedStatus.plcLocked) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `Please contact admin for unlocking the deployment.`
      );
    } else {
      if (!pagesValidated.programPage && !pagesValidated.systemsPage) {
        if(type === "PLC"){
          setEmoController((prevState) => ({
          ...prevState,
          plcKeyPopUp: true,
          serialNo: emoSerialNumber ? emoSerialNumber : "",
          KeyErrorStatusSerialNo: false,
        }));
        }else{
          setIpcController((prevState) => ({
          ...prevState,
          ipcKeyPopUp: true,
          serialNo: ipcSerialNumber ? ipcSerialNumber : "",
          KeyErrorStatusSerialNo: false,
        }));
        }
      } else {
        if (pagesValidated.programPage) {
          setAlertMessage(
            `Alert`,
            false,
            ``,
            `Please validate use case to proceed further in Configure use cases.`
          );
        } else if (pagesValidated.systemsPage) {
          setAlertMessage(
            `Alert`,
            false,
            ``,
            `Please validate communication settings to proceed further.`
          );
        }
      }
    }
  };
   
  const handleSerialNoChange = (e, type) => {
    const { value } = e.target;
    const isValid = value !== "" && alphanumericReg.test(value);

    if (type === "PLC") {
      setEmoController((prevState) => ({
        ...prevState,
        serialNo: isValid ? value : "",
        KeyErrorStatusSerialNo: !isValid,
      }));
    } else {
      setIpcController((prevState) => ({
        ...prevState,
        serialNo: isValid ? value : "",
        KeyErrorStatusSerialNo: !isValid,
      }));
    }
  };

  const handleSerialNoPopUpClose = (type) => {
    if(type === "PLC"){
        setEmoController((prevState) => ({
      ...prevState,
      plcKeyPopUp: false,
      serialNo: "",
      KeyErrorStatusSerialNo: false,
    }));
    }else{
       setIpcController((prevState) => {
      return {
        ...prevState,
      ipcKeyPopUp: false,
      serialNo: "",
      KeyErrorStatusSerialNo: false,
      }
    });
    }
  
    
  };

  const handleSerialNoSave = () => {
    if (
      emoController.serialNo !== "" &&
      checkMaxLength(emoController.serialNo, emoController.serialNo.length)
    ) {
      setEmoController((prevState) => ({
        ...prevState,
        plcKeyPopUp: false,
      }));
      generateProgram();
    } else {
      callSnackbar(
        `error`,
        `Please enter Controller serial number in the given format`
      );
    }
  };
  const checkMaxLength = (value, maxLength) => {
    if(maxLength === 10){
      return serialNoRegex_10.test(value);  
    }else{
      return serialNoRegex_13.test(value);  
    }
  }
   const handleEMACSerialNoSave = () => {
    if (
      ipcController.serialNo.length === 10 &&
      ipcController.serialNo !== "" &&
      checkMaxLength(ipcController.serialNo,  ipcController.serialNo.length )
    ) {
      setIpcController((prevState) => ({
        ...prevState,
        ipcKeyPopUp: false,
      }));
     downloadIpcFile();
    } else {
      callSnackbar(
        `error`,
        `Please enter Controller serial number in the given format`
      );
    }
  };
   
  const generateProgram = () => {
    setLoading(true);
    setUnlockDeploy(false);
    apiSession
      .generatePLCProgram({
        projectId: projectId ? projectId : 29,
        serialNumber: emoController.serialNo,
      })
      .then(() => {
        downloadPlc();
      })

      .catch((error) => {
          if (error?.response?.status === 412) {
            callSnackbar("error", error?.response?.data?.message);
          } else if (error?.response?.status === 403) {
            callSnackbar(
              "error",
              "Unauthorised to perform this action, Contact administrator."
            );
          } else {
            callSnackbar("error", error?.response?.data?.message || "Failed to download PLC");
          }

        setLoading(false);
      });
  };
   
  const downloadPlc = () => {
    let serialNumber = emoController.serialNo;
    apiSession
      .downloadPLCProgram(projectId || 29, serialNumber)
      .then((response) => {
        FileDownload(response, `${projectStatusInfo?.projectName}_EMOM.zip`);
        callSnackbar("success", "Downloaded successfully");
        setLoading(false);
        getDeploymentStatus();
        setUnlockDeploy(true);
      })
      .catch((error) => {
        setLoading(false);

        if (error.response !== undefined) {
          if (error.response.status === 423) {
            callSnackbar("error", error.response.data.message);
          }
        } else {
          callSnackbar("error", "Failed to download");
        }
      });
  };

  //* HMI
   
  const downloadHMI = () => {
    if (!pagesValidated.programPage && !pagesValidated.systemsPage) {
      setLoading(true);

      apiSession
        .downloadHMI(projectId)
        .then((response) => {
          FileDownload(response, `${projectStatusInfo?.projectName}_HMI.zip`);
          setLoading(false);
          callSnackbar("success", "Downloaded successfully");
        })
        .catch((error) => {
          setLoading(false);
          if (error.response !== undefined) {
            if (error.response.status === 403) {
              callSnackbar(
                "error",
                "Unauthorised to perform this action, Contact administrator"
              );
            } else {
              callSnackbar("error", "Failed to download");
            }
          } else {
            callSnackbar("error", "Failed to download");
          }
        });
    } else {
      if (pagesValidated.programPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate use case to proceed further in Configure use cases.`
        );
      } else if (pagesValidated.systemsPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate communication settings to proceed further.`
        );
      }
    }
  };
  const downloadBessControllerPackage = (docId, filName) => {
    if (!pagesValidated.programPage && !pagesValidated.systemsPage) {
      setLoading(true);

      apiSession
        .downloadBessControllerDocument(docId)
        .then((response) => {
          FileDownload(response,`${filName}.zip`);
          setLoading(false);
          callSnackbar("success", "Downloaded successfully");
        })
        .catch((error) => {
          setLoading(false);
           setDownloadController({ isOpen: false, packageType: "" });
          if (error.response !== undefined) {
            if (error.response.status === 403) {
              callSnackbar(
                "error",
                "Unauthorised to perform this action, Contact administrator"
              );
            } else {
              callSnackbar("error", "Failed to download");
            }
          } else {
            callSnackbar("error", "Failed to download");
          }
        });
    } else {
      if (pagesValidated.programPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate use case to proceed further in Configure use cases.`
        );
      } else if (pagesValidated.systemsPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate communication settings to proceed further.`
        );
      }
    }
  };
  
// Compare two dot-separated version strings numerically
const compareVersions = (a, b) => {
  const aParts = String(a).split('.').map(n => parseInt(n, 10) || 0);
  const bParts = String(b).split('.').map(n => parseInt(n, 10) || 0);
  const len = Math.max(aParts.length, bParts.length);

  for (let i = 0; i < len; i++) {
    const av = aParts[i] ?? 0;
    const bv = bParts[i] ?? 0;
    if (av > bv) return 1;
    if (av < bv) return -1;
  }
  return 0;
};

// Get latest entries per softwareName
const latestBySoftware = items => {
  const latest = {};

  items.forEach(item => {
    if (!item.version || String(item.version).trim() === '') return;
    const key = item.softwareName;
    if (!key) return;

    const current = latest[key];
    if (!current) {
      latest[key] = item;
      return;
    }

    const cmp = compareVersions(item.version, current.version);
    if (cmp > 0) {
      latest[key] = item;
    } else if (cmp === 0) {
      const aCreated = Number(item.createdOn) || 0;
      const bCreated = Number(current.createdOn) || 0;
      if (aCreated > bCreated) latest[key] = item;
    }
  });

  return latest;
};

// Convenience: get latest version string per softwareName
const latestVersions = items => {
  const map = latestBySoftware(items);
  return Object.fromEntries(Object.entries(map).map(([name, item]) => [name, item.version]));
};

const downloadBESSController = (type) =>{
  const newControllerList = [...bessControllerListJson];
  const controllerData = newControllerList.filter(
    (controller) => controller.softwareName === type
  );
  setDownloadController({ isOpen: true, packageType: type });
  setBessControllerList(controllerData);
}
  //MOXA
   
  const downloadMOXA = () => {
    if (!pagesValidated.programPage && !pagesValidated.systemsPage) {
      setLoading(true);
      setUnlockDeploy(false);
      apiSession
        .downloadMoxa(projectId)
        .then((response) => {
          FileDownload(response, `${projectStatusInfo?.projectName}_MOXA.zip`);
          setLoading(false);
          callSnackbar("success", "Downloaded successfully");
          setUnlockDeploy(true);
        })
        .catch((error) => {
          setLoading(false);
          if (error.response !== undefined) {
            if (error.response.status === 403) {
              callSnackbar(
                "error",
                "Unauthorised to perform this action, Contact administrator"
              );
            } else if (error.response.status === 500) {
              callSnackbar("error", "Error in file generation");
            } else if (error.response.status === 404) {
              callSnackbar(
                "error",
                "Please save secured communication architecture page"
              );
            } else {
              callSnackbar("error", "Failed to download");
            }
          } else {
            callSnackbar("error", "Failed to download");
          }
        });
    } else {
      if (pagesValidated.programPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate use case to proceed further in Configure use cases.`
        );
      } else if (pagesValidated.systemsPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate communication settings to proceed further.`
        );
      }
    }
  };
  const downloadFortiGate = () => {
    if (!pagesValidated.programPage && !pagesValidated.systemsPage) {
      setLoading(true);
      setUnlockDeploy(false);
      apiSession
        .downloadFortiGate(projectId)
        .then((response) => {
          FileDownload(response, `${projectStatusInfo?.projectName}_FortiGate.zip`);
          setLoading(false);
          callSnackbar("success", "Downloaded successfully");
          setUnlockDeploy(true);
        })
        .catch((error) => {
          setLoading(false);
          if (error.response !== undefined) {
            if (error.response.status === 403) {
              callSnackbar(
                "error",
                "Unauthorised to perform this action, Contact administrator"
              );
            } else if (error.response.status === 500) {
              callSnackbar("error", "Error in file generation");
            } else if (error.response.status === 404) {
              callSnackbar(
                "error",
                "Please save secured communication architecture page"
              );
            } else {
              callSnackbar("error", "Failed to download");
            }
          } else {
            callSnackbar("error", "Failed to download");
          }
        });
    } else {
      if (pagesValidated.programPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate use case to proceed further in Configure use cases.`
        );
      } else if (pagesValidated.systemsPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate communication settings to proceed further.`
        );
      }
    }
  };
  const downloadOnLogicHandler = async (e) => {
    sendCallToActionEvent("Projects", "Download Program", "Deploy");
    e.preventDefault();
    if (!pagesValidated.programPage && !pagesValidated.systemsPage) {
      setLoading(true);
      setUnlockDeploy(false);

      try{
          const result = await apiSession.downloadOnlogic(projectId);
          const encodeURI = result && result[0];
           if (!encodeURI || typeof encodeURI !== "string") {
              throw new Error("No valid URL returned from downloadOnlogic");
              } 
            const parts = encodeURI.split("?");
            const base = parts[0] || "";
            const query = parts[1] || "";
            const decodedQuery = decrypt(query);
            const finalUrl = `${base}?${decodedQuery}`;

          const a = document.createElement("a");
          a.href = finalUrl;
          a.download = finalUrl;
          document.body.appendChild(a);
          a.click();

          document.body.removeChild(a);
          window.URL.revokeObjectURL(finalUrl);
          setLoading(false);
        
        }catch(error){
          console.log(error);
          if (error.response !== undefined) {
            if (error.response.status === 403) {
              callSnackbar(
                "error",
                "Unauthorised to perform this action, Contact administrator"
              );
            } else if (error.response.status === 500) {
              callSnackbar("error", "Error in file generation");
            } else if (error.response.status === 404) {
              callSnackbar(
                "error",
                "Please save secured communication architecture page"
              );
            } else {
              callSnackbar("error", "Failed to download");
            }
          } else {
            callSnackbar("error", "Failed to download");
          }
        }finally{
          setLoading(false);
        }


    } else {
      if (pagesValidated.programPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate use case to proceed further in Configure use cases.`
        );
      } else if (pagesValidated.systemsPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate communication settings to proceed further.`
        );
      }
    }
  };










  
  //Connexium
   
  const downloadCONNEXIUM = () => {
    if (!pagesValidated.programPage && !pagesValidated.systemsPage) {
      setLoading(true);
      setUnlockDeploy(false);
      apiSession
        .downloadConnexium(projectId)
        .then((response) => {
          FileDownload(
            response,
            `${projectStatusInfo?.projectName}_CONNEXIUM.zip`
          );
          setLoading(false);
          callSnackbar("success", "Downloaded successfully");
          setUnlockDeploy(true);
        })
        .catch((error) => {
          setLoading(false);
          if (error.response !== undefined) {
            if (error.response.status === 403) {
              callSnackbar(
                "error",
                "Unauthorised to perform this action, Contact administrator"
              );
            } else if (error.response.status === 500) {
              callSnackbar("error", "Error in file generation");
            } else if (error.response.status === 404) {
              callSnackbar(
                "error",
                "Please save secured communication architecture page"
              );
            } else {
              callSnackbar("error", "Failed to download");
            }
          } else {
            callSnackbar("error", "Failed to download");
          }
        });
    } else {
      if (pagesValidated.programPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate use case to proceed further in Configure use cases.`
        );
      } else if (pagesValidated.systemsPage) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `Please validate communication settings to proceed further.`
        );
      }
    }
  };



  //* Licence

  const handleLicenseChange = (e) => {
    const { name, value } = e.target;

    let input = value.replace(/-/g, "");

    // Remove non-hex chars
    input = value.replace(/[^\dA-F]/gi, "");

    // Check length and insert hyphens
    if (input.length > 8) {
      input = `${input.slice(0, 8)}-${input.slice(8)}`;
    }
    if (input.length > 13) {
      input = `${input.slice(0, 13)}-${input.slice(13)}`;
    }
    if (input.length > 18) {
      input = `${input.slice(0, 18)}-${input.slice(18)}`;
    }
    if (input.length > 23) {
      input = `${input.slice(0, 23)}-${input.slice(23)}`;
    }

    setKeyOperations((prevState) => ({
      ...prevState,
      [name]: input,
    }));
  };

  const validateExpertKey = () => {
    if (keyExpert.expertKey.trim() !== "") {
      saveExpertKey();
    } else {
      callSnackbar("error", "License Key is mandatory");
    }
  };

  const saveExpertKey = () => {
    setLoading(true);

    let jsonBody = {
      projectId: projectId,
      activationKey: keyExpert.expertKey.toUpperCase(),
      type: "EXPERT",
    };

    setKeyExpert((prevState) => ({
      ...prevState,
      expertKeyInvalid: false,
    }));

    apiSession
      .activateLicenseKey(jsonBody)
      .then((response) => {
        setKeyExpert((prevState) => ({
          ...prevState,
          expertKey: "",
          expertStatus: true,
          KeyErrorStatusExpert: false,
        }));
        callSnackbar("success", response.message);
        getDeploymentStatus();
         setLoading(false);
      })
      .catch((error) => {
        if (error.response !== undefined) {
          if (error.response.status === 400) {
            setKeyExpert((prevState) => ({
              ...prevState,
              expertKeyInvalid: true,
            }));
          }
          callSnackbar("error", error.response.data.message);
        } else {
          callSnackbar("error", "Error calling license API");
        }
        setLoading(false);

        setKeyExpert((prevState) => ({
          ...prevState,
          expertStatus: false,
        }));
      });
  };

  const validateOpertaionsKey = () => {
    if (keyOperations.operationKey.trim() !== "") {
      sendCallToActionEvent("Projects", "Submit", "Deploy");
      saveOperationsKey();
    } else {
      callSnackbar("error", "License Key is mandatory");
    }
  };

  const saveOperationsKey = () => {
    setLoading(true);

    let jsonBody = {
      projectId: projectId,
      activationKey: keyOperations.operationKey.toUpperCase(),
      type: "OPERATIONS",
    };

    setKeyOperations((prevState) => ({
      ...prevState,
      operationKeyInvalid: false,
    }));

    apiSession
      .activateLicenseKey(jsonBody)
      .then((response) => {
         setLoading(false);
        setKeyOperations((prevState) => ({
          ...prevState,
          operationKey: "",
          operationsStatus: true,
          KeyErrorStatusOperations: false,
        }));
        callSnackbar("success", response.message);
        getDeploymentStatus();
      })
      .catch((error) => {
        if (error.response !== undefined) {
          if (error.response.status === 400) {
            setKeyOperations((prevState) => ({
              ...prevState,
              operationKeyInvalid: true,
            }));
          }
          callSnackbar("error", error.response.data.message);
        } else {
          callSnackbar("error", "Error calling license API");
        }

        setLoading(false);
        setKeyOperations((prevState) => ({
          ...prevState,
          operationsStatus: false,
        }));
      });
  };

  useEffect(() => {
    let allowUnlock = true;
    if (
      deploymentStatusResponse?.licenseMatched === "NOT_FOUND" &&
      !deploymentStatusResponse?.deploymentStatus
    ) {
      // setOpenDialog(true);
      // setDeployMessage(
      //   "License Not Found"
      // );
    } else if (
      deploymentStatusResponse?.licenseMatched === "NOT_MATCHED" &&
      !deploymentStatusResponse?.deploymentStatus
    ) {
      setOpenDialog(true);

      setDeployMessage(
        "Please contact the country front office team/MGCC team to order right bill of material"
      );
    } else if (
      deploymentStatusResponse?.licenseMatched === "EXPIRED" &&
      !deploymentStatusResponse?.deploymentStatus
    ) {
      setOpenDialog(true);
      setDeployMessage(
        "Please contact the country front office team/MGCC team to renew your subscription"
      );

      allowUnlock = false;
    } else {
      allowUnlock = true;
    }
  }, [projectStateChanges, deploymentStatusResponse]);
  //* unlock

  const unlockDeployHandler = (data) => {
    if (
      (UserScope.access.unlock === true &&
        projectStatusInfo?.projectStatus === "COMPLETED") ||
      projectStatusInfo?.projectStatus === "COMPLETED_AND_SEND"
    ) {
      apiSession
        .unlockDeploy(projectId, data?.detail?.selected)
        .then(async (response) => {
          setKeyExpert((prevState) => ({
            ...prevState,
            KeyErrorStatusExpert: false,
          }));
          setKeyOperations((prevState) => ({
            ...prevState,
            KeyErrorStatusOperations: false,
          }));

          setUnlockDeploy((prevState) => !prevState);
          // setUnlockDeploy(data.detail.selected);
          callSnackbar("success", "Unlock updated successfully");
          setDeployMessage("");
          await getDeploymentStatus();
        })
        .catch((error) => {
          if (data.detail.selected === true) {
            setUnlockDeploy(false);
          }

          if (error?.response?.status === 412) {
            callSnackbar(
              "error",
              "Please ensure Assets Configuration is complete to deploy"
            );
          } else {
            callSnackbar("error", "Error in updating unlock");
          }
        });
    } else if (deploymentStatusResponse?.licenseMatched === "NOT_FOUND") {
      callSnackbar("error", "License Not Found");
    } else {
      callSnackbar("error", "Not Authorized");
    }
  };

  const confirmResetPlc = () => {
    setLoading(true);
    apiSession
      .resetPLC({ projectId: projectId })
      .then(() => {
        setResetPlcPopUpStatus(false);
        getDeploymentStatus();
        setLoading(false);
        callSnackbar("success", "Cleared project PLC count successfully");
      })
      .catch(() => {
        setLoading(false);
        setResetPlcPopUpStatus(false);
        callSnackbar("error", "Error in clear PLC count");
      });
  };

  //* alerts
  const callSnackbar = useCallback((type, message) => {
    try {
      setSnackBar({ type, message });
      snackBarRef.current.open = true;
    } catch (error) {
      console.log("error in snack bar");
    }
  }, []);

  const setAlertMessage = (title, isRoute, routePath, message) => {
    setAlert({
      title,
      isRoute,
      routePath,
      message,
      alertPopUpStatus: true,
    });
  };

  const getAllDocuments = () => {
    try {
      apiSession
        .listAllDeployDocuments(projectId, "deploy")
        .then((response) => {
          setDocumentList(response.documentBlobInfo);
        });

    } catch (error) {
      console.log(error);
    }
  };

  const getEmoDoc = async() => {
    try {
      const result = await apiSession.ioCardDetails(projectId);
      if (result) {
        setEmoDocList(result);
      }
    }catch (error) {
      console.log(error);
    }

  }

  const closeAlertMessage = useCallback(() => {
    setAlert({
      message: "",
      alertPopUpStatus: false,
      title: "",
      isRoute: false,
      routePath: "",
    });
    if (alert.isRoute) {
      let { history } = props;
      history.push({
        pathname: `/${alert.routePath}`,
      });
    }
  }, [alert, props]);
  const orderNumberChangeHandler = (e) => {
    const value = e.target.value.replace(/ +(?= )/g, "");
    let orderNumberRegex = /^$|^[0-9]+$/;
    if (orderNumberRegex.test(value)) {
      setOrderNumber(value);
      setOrderNumberError(false);
    } else {
      setOrderNumberError(true);
    }
  };
  const openProgramModel = (title, type) => {
    setProgramTitle(title);
    setFileType(type);
    setOpenUploadFile({
      isOpen: true,
      packageType: type,
    });
  };

  const fileChangedHandler = (event) => {
    const { files } = event.target;
    if (files.length) {
      if (files[0].size > 104857600) {
        callSnackbar(
          "error",
          "EMA Configuration zip file should be less than 100MB"
        );
        event.target.value = null;
        setSelectedFile(null);
      } else if (files[0].type !== "application/x-zip-compressed") {
        callSnackbar("error", "Invalid file format, Please select .zip file");
        event.target.value = null;
        setSelectedFile(null);
      } else {
        setSelectedFile(files[0]);
        // setTags((prevState) => ({
        //   ...prevState,
        //   plcTag: files[0].name,
        // }));
        let reader = new FileReader();
        reader.onloadend = () => {};
        reader.readAsDataURL(files[0]);
      }
    }
  };
  const uploadProgramFiles = (type) => {
    if (fileInfo?.name === "") {
      callSnackbar("error", "File name is mandatory");
    } else if (fileInfo?.description === "") {
      callSnackbar("error", "File Description is mandatory");
    } else if (selectedFile === null) {
      callSnackbar("error", "File is mandatory");
    } else {
      setLoading(true);
      let fd = new FormData();
      fd.append("file", selectedFile);
      if (!downloadProgram?.isOpen) {
        fd.append("type", type);
      }

      fd.append("Name", fileInfo?.name);
      fd.append("Description", fileInfo.description);
      fd.append("projectId", projectId);
      fd.append("deployPageUploadedPackage", true);

      setOpenUploadFile({
        isOpen: false,
        packageType: "",
      });
      fd.append("projectType", "");
      apiSession
        .uploadProgramAndConfig(fd)
        .then((res) => {
          if (res) {
            setLoading(false);
            setUploadedPackage(false);
            callSnackbar("success", "Successfully uploaded package");
            setSelectedFile(null);
          }
        })
        .catch((error) => {
          if (error.response !== undefined) {
            if (error.response.status === 400) {
              callSnackbar("error", "Invalid package");
            } else {
              callSnackbar("error", "Error in uploading package");
            }
          } else {
            callSnackbar("error", "Error in uploading package");
          }

          setLoading(false);
        });
      setFileInfo({
        name: "",
        description: "",
      });
    }
  };

  const deleteUploadPackage = (type, id) => {
    setLoading(true);
    apiSession
      .deleteUploadPackage(projectId, type, id)
      .then((res) => {
        setLoading(false);
        callSnackbar("success", " Successfully delete package");
      })
      .catch((error) => {
        setLoading(false);
        callSnackbar("error", "Error in delete package");
      });
  };
  const downloadDeployPackage = (type, id, name) => {
    setLoading(true);
    apiSession
      .downloadDeployPackage(projectId, type, id)
      .then((response) => {
        setLoading(false);
        FileDownload(response, name);
        callSnackbar("success", "Downloaded successfully");
      })
      .catch((error) => {
        setLoading(false);
        callSnackbar("error", "Error in download package");
      });
  };
  return (
    <>
      <div
        className={`${
          openStatusDialog && UserScope?.role !== "Viewer"
            ? "main-container"
            : ""
        } container-fluid  container-margin h-100`}
      >
        <div className="d-flex justify-content-end align-items-end flex-column">
          {UserScope?.access?.saveProjects && (
            <se-dropdown alignment="right">
              {/* <se-button option="flat" color="primary">Generate Task</se-button> */}

              <se-button
                slot="trigger"
                option="flat"
                color="primary"
                icon-color="primary"
              >
                Update Status
              </se-button>
              <se-list option="dropdown">
                <se-divider></se-divider>
                <se-list-item
                  onClick={() =>
                    (emaSiteStatus && projectTypeValue !== NMGAAS_ETO)
                      ? setOpenSiteCreate(true)
                      : handleChangeProjectStatus("IN_PROGRESS")
                  }
                  /**don't change class to className here */
                  className={
                    projectStatusInfo?.projectStatus === "IN_PROGRESS"
                      ? "disable-button"
                      : "enable-button"
                  }
                  item="In Progress"
                  disabled={projectStatusInfo?.projectStatus === "IN_PROGRESS"}
                ></se-list-item>
                <se-divider></se-divider>
                <se-list-item
                  onClick={() => {
                    setOpen(true);
                    setProjectStatusClick("Completed");
                  }}
                  /**don't change class to className here */
                  className={
                    projectStatusInfo?.projectStatus === "COMPLETED"
                      ? "disable-button"
                      : "enable-button"
                  }
                  disabled={projectStatusInfo?.projectStatus === "COMPLETED"}
                  item="Completed"
                ></se-list-item>
                <se-divider></se-divider>
                {deploymentStatusResponse?.isFactoryUsersAvailable && (
                  <>
                    <se-list-item
                      onClick={() => {
                        setOpen(true);
                        setProjectStatusClick("Completed & Send");
                      }}
                      /**don't change  class to className here */
                      className={
                        projectStatusInfo?.projectStatus ===
                        "COMPLETED_AND_SEND"
                          ? "disable-button"
                          : "enable-button"
                      }
                      disabled={
                        projectStatusInfo?.projectStatus ===
                        "COMPLETED_AND_SEND"
                      }
                      item="Completed & Send"
                    ></se-list-item>
                    <se-divider></se-divider>
                  </>
                )}
              </se-list>
            </se-dropdown>
          )}
          <div
            className="flex-10 ml-2 se-font-14px-bold se-life-green mb-2 mt-2"
            style={{
              display: `flex`,
              alignItems: "baseline",
              justifyContent: "space-between",
              flexDirection: "column"
            }}
          >
            {documentList?.length > 0 &&
              (deploymentStatusResponse?.licenseMatched === "MATCHED" ||
                unlockDeploy) && (
                <SeLink
                  href=""
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setShowSupportDocumentDialog(true);
                  }}
                >
                  Support Document <SeIcon>action_layer_forward</SeIcon>
                </SeLink>
              )}

           
          </div>
          {open && (
            <se-dialog
              id="dialog-simple-notitle"
              color="alternative"
              size="small"
              open={open}
            >
              <se-dialog-header color="primary">
                Update Status{" "}
              </se-dialog-header>
              <se-dialog-content color="primary">
                <div className="d-flex ">
                  <span>
                    <se-icon size="small" icon="information_circle">
                      information_circle
                    </se-icon>
                  </span>
                  <span>
                    {deploymentStatusResponse?.isFactoryUsersAvailable &&
                    projectStatusClick === "Completed & Send"
                      ? "User allows the settings to be uploaded to the microgrid controls. A ECC manufacturing facility user will be added to the project and an email will be triggered to the factory which would allow them to download the configuration based on the order number"
                      : "User allows the settings to be uploaded to the microgrid controls"}
                  </span>
                </div>
                {(projectTypeValue === DAAS_ANSI ||projectTypeValue === DAAS_ETO ||
                  projectTypeValue === MGAAS_ANSI) && (
                  <div className={` form-group row`}>
                    <label
                      htmlFor="inputEmail3"
                      className="col-sm-4 col-form-label text-right d-flex justify-content-center align-items-center"
                    >
                      <span> Order Number</span>
                      <span className="se-block-enabled">
                        <se-tooltip position="left">
                          <se-icon
                            option="raised"
                            slot="tooltip"
                            color="secondary"
                          >
                            information_circle
                          </se-icon>
                          <se-tooltip-content
                            style={{
                              textAlign: "left",
                              display: "block",
                              width: "295px",
                            }}
                          >
                            {"ECC/Switchboard/Flex Software order number"}
                          </se-tooltip-content>
                        </se-tooltip>
                      </span>
                    </label>
                    <div className="col-sm-8">
                      {/* {projectInformation.projectId} */}
                      <input
                        type="text"
                        autoComplete="none"
                        className="form-control form-control-md"
                        name="q2cOrderNumber"
                        maxLength="60"
                        value={orderNumber}
                        onChange={orderNumberChangeHandler}
                      />

                      <div
                        className={`${
                          orderNumberError && !/^\d+(\.\d+)?$/.test(orderNumber)
                            ? "invalid-feedback-custom"
                            : "hidden"
                        }`}
                      >
                        {embLabels.allowednumericvalues}
                      </div>
                    </div>
                  </div>
                )}
              </se-dialog-content>
              <se-dialog-footer>
                <se-button onClick={() => setOpen(false)}>Cancel</se-button>
                <se-button
                  color="primary"
                  onClick={() => dialogHandler()}
                  disabled={
                    projectTypeValue === DAAS_ANSI || projectTypeValue === DAAS_ETO ||
                    projectTypeValue === MGAAS_ANSI
                      ? orderNumber === ""
                        ? true
                        : false
                      : false
                  }
                >
                  Allow
                </se-button>
              </se-dialog-footer>
            </se-dialog>
          )}
        </div>
        {loading && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: "100009",
            }}
          >
            {" "}
            <se-loading loading={loading}></se-loading>
          </div>
        )}
       
        {siteType && (
          <se-container option="centered">
            <div className="container mb-1 mt-1">
              <div className="row">
                <div className="col-md-12 p-0">
                  <span className="se-life-green se-font-14px-bold">
                    License{" "}
                  </span>
                </div>
              </div>
              <LicenceKeys
                UserScope={UserScope}
                gridSetting={gridSetting}
                unlockDeploy={unlockDeploy}
                siteType={siteType}
                architectureType={architectureType}
                keyExpert={keyExpert}
                keyOperations={keyOperations}
                handleLicenseChange={handleLicenseChange}
                validateExpertKey={validateExpertKey}
                validateOpertaionsKey={validateOpertaionsKey}
                projectProgressStatus={projectStatusInfo}
              />
              <Services
                projectKind={projectKind}
                latestVersionMap = {latestVersionMap}
                UserScope={UserScope}
                gridSetting={gridSetting}
                unlockDeploy={unlockDeploy}
                siteType={siteType}
                bessControllerAvailable={bessControllerAvailable}
                masterBessControllerAvailable ={masterBessControllerAvailable}
                clientType={clientType}
                architectureType={architectureType}
                keyExpert={keyExpert}
                keyOperations={keyOperations}
                emaSiteStatus={emaSiteStatus}
                versions={versions}
                createSiteInEMA={createSiteInEMA}
                deleteSiteInEMA={deleteSiteInEMA}
                setDownloadProgram={setDownloadProgram}
                downloadIpcFile={downloadIpcFile}
                downloadOnLogicFile={downloadOnLogicFile}
                handleSerialNoPopUp={handleSerialNoPopUp}
                downloadHMI={downloadHMI}
                downloadMOXA={downloadMOXA}
                downloadFortiGate = {downloadFortiGate}
                downloadCONNEXIUM={downloadCONNEXIUM}
                downloadOnLogic={downloadOnLogicHandler}
                projectProgressStatus={projectStatusInfo}
                emaSiteId={emaSiteId}
                deploymentStatus={deploymentStatusResponse}
                currentProject={currentProject}
                openProgramModel={openProgramModel}
                projectId={projectId}
                setUploadedPackage={setUploadedPackage}
                setOpenUploadFile={setOpenUploadFile}
                setShowConfig = {setShowConfig}
                emoDocList = {emoDocList}
                gatewayType = {gatewayType}
                setAlertMessage = {setAlertMessage}
                downloadBESSController = {downloadBESSController}
                navigateToEMOM = {navigateToEMOM}
              />

              {UserScope.access.unlock === true ? (
                <div className="row mt-2 d-flex justify-content-center">
                  <div
                    className={` d-flex justify-content-center col-md-3 tab-content-deploy ${
                      projectStatusInfo?.projectStatus === "IN_PROGRESS"
                        ? "se-block-disabled deploy-btn"
                        : ""
                    }`}
                  >
                    <div className="se-deploy-div">
                      {/* <label> Unlock Deployment</label>&nbsp;&nbsp;&nbsp;&nbsp; */}

                      <SeCheckbox
                        value="true"
                        disabled={
                          projectStatusInfo?.projectStatus === "IN_PROGRESS" ||
                          UserScope.access.unlock === true
                            ? false
                            : true
                        }
                        option="switch"
                        selected={unlockDeploy}
                        label="Unlock Deployment"
                        onDidChange={(e) => unlockDeployHandler(e)}
                      ></SeCheckbox>
                      {openDialog &&
                        (projectStatusInfo?.projectStatus === "COMPLETED" ||
                          projectStatusInfo?.projectStatus ===
                            "COMPLETED_AND_SEND") && (
                          <se-dialog
                            id="dialog-simple-notitle"
                            color="alternative"
                            size="small"
                            open={openDialog}
                          >
                            <se-dialog-header color="primary">
                              License validation failed{" "}
                            </se-dialog-header>
                            <se-dialog-content
                              icon="information_circle"
                              color="primary"
                              style={{ textAlign: "start" }}
                            >
                              {deployMessage}
                              {deploymentStatusResponse?.licenseMatched ===
                                "NOT_MATCHED" &&
                                deploymentStatusResponse?.licenses &&
                                Object.keys(
                                  deploymentStatusResponse?.licenses
                                ) && (
                                  <>
                                    {Object.keys(
                                      deploymentStatusResponse?.licenses
                                    ).map((licence) => (
                                      <li>{licence}</li>
                                    ))}
                                  </>
                                )}
                            </se-dialog-content>
                            <se-dialog-footer>
                              <se-button onClick={() => setOpenDialog(false)}>
                                OK
                              </se-button>
                            </se-dialog-footer>
                          </se-dialog>
                        )}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {((siteType === "GRID_CONNECTED"
                ? keyExpert.expertStatus
                : keyOperations.operationsStatus) ||
                unlockDeploy === true ||
                UserScope.access.unlockBypass === true) &&
              UserScope.access.resetPLC === true ? (
                <div className="row mt-2 justify-content-center">
                  <div className="col-md-4 p-2">
                    <div className="row">
                      <div className="col-md-6 mt-1 my-auto text-right">
                        <span className="bold">Reset PLC Count</span>
                      </div>
                      <div className="col-md-6 mt-1 my-auto">
                        <se-button
                          size="small"
                          title="Reset PLC Count"
                          onClick={() => setResetPlcPopUpStatus(true)}
                        >
                          <se-icon size="small">data_refresh_stroke</se-icon>
                        </se-button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            {emoController.plcKeyPopUp && (
              <DownloadController
                title="EMO-M controller protection"
                controller={emoController}
                serialNumber={emoSerialNumber}
                handleSerialNo={(e)=>handleSerialNoChange(e, "PLC")}
                handleSerialNoPopUpClose={()=>handleSerialNoPopUpClose("PLC")}
                handleSerialNoSave={handleSerialNoSave}
                keyImage = {keyImagePLC}
                status = {emoController.plcKeyPopUp}
                isDisplayKeyImage = {true}
                maxLength = {13}
              />
            )}
              
             {ipcController.ipcKeyPopUp && emaSiteStatus && (
              <DownloadController
                title ="EMA Controller Configuration"
                controller={ipcController}
                serialNumber={ipcSerialNumber}
                handleSerialNo={(e)=>handleSerialNoChange(e, "IPC")}
                handleSerialNoPopUpClose={()=>handleSerialNoPopUpClose("IPC")}
                handleSerialNoSave={handleEMACSerialNoSave}
                // keyImage = {keyImageIPC}
               isDisplayKeyImage = {false}
                status = {ipcController.ipcKeyPopUp}
                
              />
            )}

            <Snackbar snackBar={snackBar} ref={snackBarRef} />
            <AlertIcon alert={alert} onClose={closeAlertMessage} />

            <se-dialog
              id="no-project-alert-popup"
              open={confirm.deleteSiteAlertPopUp}
              can-backdrop="false"
            >
              <se-dialog-header>Confirmation</se-dialog-header>
              <se-dialog-content className="se-header-font-size-16px ">
                <se-icon color="primary" size="small">
                  information_circle
                </se-icon>
                <span>
                  &nbsp; EMA website is running for this project, Do you want to
                  delete this EMA website ? If you delete, All site historical
                  data will be lost.
                </span>
              </se-dialog-content>
              <se-dialog-footer>
                <se-button onClick={cancelDeleteSite}>No</se-button>
                <se-button onClick={confirmDeleteSite}>Yes</se-button>
              </se-dialog-footer>
            </se-dialog>

            <se-dialog
              id="no-project-alert-popup"
              open={resetPlcPopUpStatus}
              can-backdrop="false"
            >
              <se-dialog-header>Confirmation</se-dialog-header>
              <se-dialog-content>
                <span className="se-font-14px">
                  Do you confirm to clear count ?
                </span>
              </se-dialog-content>
              <se-dialog-footer>
                <se-button onClick={() => setResetPlcPopUpStatus(false)}>
                  NO
                </se-button>
                <se-button onClick={confirmResetPlc}>Yes</se-button>
              </se-dialog-footer>
            </se-dialog>
          </se-container>
        )}
        {openDialog && (
          <div className={openStatusDialog ? "se-block-disabled" : ""}>
            <se-dialog
              id="dialog-simple-notitle"
              color="alternative"
              size="small"
              open={openDialog}
            >
              <se-dialog-header color="primary">
                License validation Failed{" "}
              </se-dialog-header>
              <se-dialog-content
                icon="information_circle"
                color="primary"
                style={{ textAlign: "start" }}
              >
                {deployMessage}
                {deploymentStatusResponse?.licenseMatched === "NOT_MATCHED" &&
                  deploymentStatusResponse?.licenses &&
                  Object.keys(deploymentStatusResponse?.licenses) && (
                    <>
                      {Object.keys(deploymentStatusResponse?.licenses).map(
                        (licence) => (
                          <li>{licence}</li>
                        )
                      )}
                    </>
                  )}
              </se-dialog-content>
              <se-dialog-footer>
                <se-button onClick={() => setOpenDialog(false)}>OK</se-button>
              </se-dialog-footer>
            </se-dialog>
          </div>
        )}
        {openStatusDialog && UserScope?.role !== "Viewer" && (
          <div
            className={`${
              !currentProject?.showDeploy ? "hidden" : "custom-dialog"
            }`}
            color="alternative"
            size="small"
            id="no-project-alert-popup1"
          >
            <div className="custom-dialog-content">
              <se-dialog-content className="font-block-header">
                Please update the status of the project to enable deployment.
                Configurations can be downloaded only when the status of the
                project is completed.
              </se-dialog-content>
              <se-dialog-footer>
                <se-button
                  color="secondary"
                  onClick={() => {
                    setOpenStatusDialog(false);
                  }}
                >
                  OK
                </se-button>
              </se-dialog-footer>
              <div className="arrow"></div>
            </div>
          </div>
        )}
        {openSiteCreate && (
          <se-dialog
            id="dialog-simple-site-created"
            color="alternative"
            size="small"
            open={openSiteCreate}
          >
            <se-dialog-header color="primary">Update Status </se-dialog-header>
            <se-dialog-content icon="information_circle" color="primary">
              The site has been created. Please delete the site from the cloud
              service and then update the project status.
            </se-dialog-content>
            <se-dialog-footer>
              {/* <se-button onClick={() => setOpenSiteCreate(false)}>Cancel</se-button> */}
              <se-button
                color="primary"
                onClick={() => setOpenSiteCreate(false)}
              >
                Ok
              </se-button>
            </se-dialog-footer>
          </se-dialog>
        )}
        {openUploadFile?.isOpen && (
          <se-dialog
            id="dialog-simple-site-created"
            color="alternative"
            size={"large"}
            open={openUploadFile?.isOpen}
          >
            <se-dialog-header color="primary">
              {`Upload ${programTitle} Package`}{" "}
            </se-dialog-header>
            <se-dialog-content>
              <div className="row mb-2">
                <div className="col-sm-12 mt-2">
                  <div className="form-group row mb-3">
                    <label
                      htmlFor="inputEmail3"
                      className="col-sm-2 col-form-label text-right"
                    >
                      Name <span className="se-mandatory">*</span>
                    </label>
                    <div className="col-sm-10">
                      <input
                        className="form-control form-control-md"
                        id="validationTextarea"
                        name="name"
                        placeholder="Name"
                        maxLength="10"
                        value={fileInfo?.name}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFileInfo((prev) => {
                            return {
                              ...prev,
                              name: value,
                            };
                          });
                        }}
                      ></input>
                    </div>
                  </div>
                  <div className="form-group row mb-2">
                    <label
                      htmlFor="inputEmail3"
                      className="col-sm-2 col-form-label text-right"
                    >
                      Description <span className="se-mandatory">*</span>
                    </label>
                    <div className="col-sm-10">
                      <textarea
                        className="form-control form-control-md"
                        id="validationTextarea"
                        name="description"
                        placeholder="Description"
                        maxLength="1000"
                        value={fileInfo?.description}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFileInfo((prev) => {
                            return {
                              ...prev,
                              description: value,
                            };
                          });
                        }}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-sm-2"></div>
                <div className="col-sm-3 pl-1">
                  <input
                    type="file"
                    accept="application/zip"
                    onChange={fileChangedHandler}
                    className="form-control-file form-control-sm fileNameDisplay"
                    name="file"
                    ref={inputRefFile}
                  />
                </div>
                <div className="col-sm-7 text-right mb-2">
                  <se-button
                    onClick={() => {
                      setOpenUploadFile({
                        isOpen: false,
                        packageType: "",
                      });
                      setFileInfo({
                        name: "",
                        description: "",
                      });
                    }}
                  >
                    Cancel
                  </se-button>
                  <se-button
                    color="primary"
                    onClick={() =>
                      uploadProgramFiles(openUploadFile?.packageType)
                    }
                  >
                    Upload
                  </se-button>
                </div>
              </div>
            </se-dialog-content>
          </se-dialog>
        )}
        {uploadedPackage && Object.keys(uploadedPackage).length > 0 && !downloadProgram?.isOpen && (
          <se-dialog
            id="dialog-package-upload"
            color="alternative"
            size={"large"}
            open={true}
            can-backdrop="false"
          >
            <se-dialog-header color="primary">
              {`Upload ${programTitle} Package`}{" "}
            </se-dialog-header>

            <se-dialog-content>
              <div className="row  p-3">
                <div className="col-sm-12 mt-2">
                  <div className="form-group row mb-3">
                    <label
                      htmlFor="inputEmail3"
                      className="col-sm-2 col-form-label text-right"
                    >
                      Name <span className="se-mandatory">*</span>
                    </label>
                    <div className="col-sm-5">
                      <input
                        className="form-control form-control-md"
                        id="validationTextarea"
                        name="name"
                        placeholder="Name"
                        maxLength="10"
                        value={fileInfo?.name}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFileInfo((prev) => {
                            return {
                              ...prev,
                              name: value,
                            };
                          });
                        }}
                      ></input>
                    </div>
                    <div className="col-sm-5">
                      <label
                        style={{
                          position: "absolute",
                          top: "4px",
                          left: "17px",
                          background: "var(--se-background-alternative)",
                          height: "32px",
                          width: "100px",
                          borderRight: "1px solid #ced4da",
                          borderRadius: "1px",
                          display: "flex",
                          alignItems: "anchor-center",
                          justifyContent: "space-evenly",
                          fontSize: "14px",
                          fontFamily:
                            "Nunito, Roboto, Arial, Helvetica, sans-serif",
                        }}
                        for="files"
                      >
                        Choose File
                      </label>
                      <input
                        type="file"
                        accept="application/zip"
                        onChange={fileChangedHandler}
                        className="form-control form-control-md"
                        name="file"
                        ref={inputRefFile}
                        id="files"
                        style={{ padding: "5px 2px 2px 1px" }}
                      />
                    </div>
                  </div>
                  <div className="form-group row mb-2">
                    <label
                      htmlFor="inputEmail3"
                      className="col-sm-2 col-form-label text-right"
                    >
                      Description <span className="se-mandatory">*</span>
                    </label>
                    <div className="col-sm-10">
                      <textarea
                        className="form-control form-control-md"
                        id="validationTextarea"
                        name="description"
                        placeholder="Description"
                        maxLength="1000"
                        value={fileInfo?.description}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFileInfo((prev) => {
                            return {
                              ...prev,
                              description: value,
                            };
                          });
                        }}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 d-flex align-items-center  mt-2">
                  <se-icon
                    option="raised"
                    slot="tooltip"
                    color="primary"
                    className="icon-small hydrated"
                  >
                    information_circle
                  </se-icon>
                  <span>
                    EMOM Package already exists for this project. Your package
                    will be replaced with the new one
                  </span>
                </div>
             {  uploadedPackage && Object.keys(uploadedPackage).length > 0 && <div className="table-responsive col-sm-12 mt-3">
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr align="center">
                        <th>S.no.</th>
                        <th>Document Name</th>
                        <th>Description</th>
                        <th>Uploaded By</th>
                        <th>Uploaded On</th>

                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {uploadedPackage && (
                        <tr align="center">
                          <td width="10%">1.</td>
                          <td width="25%">{uploadedPackage?.documentName}</td>
                          <td width="10%">{uploadedPackage?.description}</td>
                          <td width="10%">
                            {uploadedPackage?.uploadedBy?.firstName}
                          </td>
                          <td width="10%">{uploadedPackage?.uploadedOn}</td>

                          <td width="10%">
                            <se-icon
                              size="small"
                              color="primary"
                              style={{ cursor: "pointer", marginRight: "2px" }}
                              onClick={() => {
                                downloadDeployPackage(
                                  uploadedPackage?.uploadType,
                                  uploadedPackage?.id,
                                  uploadedPackage?.documentName
                                );
                                // onClose();
                              }}
                            >
                              action_download_stroke
                            </se-icon>
                            <se-icon
                              size="small"
                              color="primary"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                deleteUploadPackage(
                                  uploadedPackage?.uploadType,
                                  uploadedPackage?.id
                                );
                                // onClose();
                                setUploadedPackage({})
                              }}
                            >
                              action_delete_stroke
                            </se-icon>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>}
                <div className="col-sm-12 text-right mt-2 mb-2">
                  <se-button
                    onClick={() => {
                      setFileInfo({
                        name: "",
                        description: "",
                      });
                      setDownloadProgram((prev) => {
                        return { isOpen: false, packageType: "" };
                      });
                      setUploadedPackage(null);
                    }}
                  >
                    Cancel
                  </se-button>
                  <se-button
                    color="primary"
                    onClick={() => uploadProgramFiles(fileType)}
                  >
                    Upload
                  </se-button>
                </div>
              </div>
            </se-dialog-content>
          </se-dialog>
        )}
      </div>
      {downloadProgram?.isOpen && (
        <DownloadConfiguration
          deleteUploadPackage={deleteUploadPackage}
          downloadDeployPackage={downloadDeployPackage}
          uploadedPackage={uploadedPackage}
          isOpen={downloadProgram?.isOpen}
          handleSerialNoPopUp={handleSerialNoPopUp}
          downloadHMI={downloadHMI}
          downloadMOXA={downloadMOXA}
          downloadFortiGate = {downloadFortiGate}
          downloadCONNEXIUM={downloadCONNEXIUM}
          downloadIpcFile={downloadIpcFile}
          title={downloadProgram?.packageType}
          programType={downloadProgram}
          onClose={() => {
            setDownloadProgram({
              isOpen: false,
              packageType: "",
            });
            setUploadedPackage(null);
          }}
        />
      )}
      <DownloadBessController
        isOpen ={downloadController.isOpen}
        downloadBessControllerPackage={downloadBessControllerPackage}
         title={downloadController.packageType}
        bessControllerList={bessControllerList}
        onClose={() => {
            setDownloadController({
              isOpen: false,
              packageType: "",
            })}
          }
       
      />
      <SupportDocument
        onClose={() => setShowSupportDocumentDialog(false)}
        showSupportDocumentDialog={showSupportDocumentDialog}
        documentList={documentList}
      />

      <IOConfig
        onClose={() => setShowConfig(false)}
        showConfig={showConfig}
        documentList={emoDocList}
      />
    </>
  );
};

export default withRouter(Deploy);
